// Copyright (c) 2016 Deere & Company

import PipClaimContainer from '../../claim/pip/state-connector';

export default {
    component: PipClaimContainer,
    name: 'PIP',
    path: 'pip/non-tracked/new(/:untrackedPipId)'
};



// WEBPACK FOOTER //
// ./src/routes/claims/pip-claim-route-with-pip-id.js